const {registrationStart, registrationEnd, eventStart} = require("../Dates");
const {Section, slug} = require("./Sections");

function defaultSections() {
  return [new Section("More Details To Come", "Watch this space for details such as parking information, where to meet, what to wear, etc.")];
}

class City {
  constructor(name,
              state,
              stateAbbreviation,
              ownerFirstName,
              ownerLastName,
              ownerEmail,
              ticketSalesUrl = null,
              eventGmtOffset = null,
              eventTimeZone = null,
              startTimeOffset = 0,
              registrationStartDayInMarch = "04",
              regStartOffset = 0,
              eventStartLocation = null,
              sections = defaultSections()
              ) {
    this.name = name;
    this.state = state;
    this.stateAbbreviation = stateAbbreviation;
    this.ownerFirstName = ownerFirstName;
    this.ownerLastName = ownerLastName;
    this.ownerEmail = ownerEmail;
    this.sections = sections;
    this.slug = slug(name);
    this.ticketSalesUrl = ticketSalesUrl;
    this.registrationStartDateTime = registrationStart(eventGmtOffset, eventTimeZone, registrationStartDayInMarch, regStartOffset);
    this.registrationEndDateTime = registrationEnd(eventGmtOffset, eventTimeZone);
    this.eventStartDateTime = eventStart(eventGmtOffset, eventTimeZone, startTimeOffset);
    this.eventStartLocation = eventStartLocation;
    this.eventGmtOffset = eventGmtOffset;
    this.eventTimeZone = eventTimeZone;
    this.ownerName = ownerFirstName + " " + ownerLastName;
  }
}

const cityList = [
  new City("Atlanta", "Georgia", "GA",	"M. Sean", "Molley",	"sean@basementsoftware.com", "https://www.eventbrite.com/e/dash-9-atlanta-tickets-32549756197", "-05:00", "America/New_York", -1),
  new City("Austin", "Texas", "TX",	"Mackenzie", "Day",	"daykenzie@gmail.com", "https://www.eventbrite.com/e/dash-9-austin-tickets-32491074679", "-06:00", "America/Chicago", 0),
  new City("Boston", "Massachusetts", "MA",	"Phil", "Steindel",	"phil.steindel@gmail.com", "https://dash9boston.eventbrite.com/", "-05:00", "America/New_York", 0),
  new City("Chicago", "Illinois", "IL",	"James", "Nelson",	"james.nelson.ii@gmail.com", "https://www.eventbrite.com/e/dash-9-chicago-tickets-32557271676", "-06:00", "America/Chicago", -1),
  new City("Davis", "California", "CA",	"Paul", "Rundle",	"p.b.rundle@gmail.com", "https://www.eventbrite.com/e/dash-9-davis-ca-tickets-32617707441", "-08:00", "America/Los_Angeles", 0),
  new City("Fremont", "California", "CA",	"Jennifer", "Chen",	"chen.jennifer.p@gmail.com", "https://www.eventbrite.com/e/dash-9-downtown-fremont-tickets-32460102039", "-08:00", "America/Los_Angeles", -1),
  new City("Los Angeles", "California", "CA",	"Cheryl", "Gaul",	"cheryl.n.gaul.p@gmail.com", "https://www.eventbrite.com/e/dash-09-los-angeles-tickets-32746813601", "-08:00", "America/Los_Angeles", -1),
  new City("Minneapolis", "Minnesota", "MN",	"Mark", "Larson",	"mrklrsn@gmail.com", "https://www.eventbrite.com/e/dash-9-minneapolis-tickets-32497389567", "-06:00", "America/Chicago", 1),
  new City("New York", "New York", "NY",	"Kevin", "Lee",	"kevin@kevlee.org",  "http://dash9nyc.eventbrite.com/", "-05:00", "America/New_York", 0),
  new City("Provo", "Utah", "UT",	"Jeremy", "Dye",	"jeremybdye@gmail.com", "https://www.eventbrite.com/e/dash-9-provo-utah-tickets-32231219445", "-07:00", "America/Denver", -1),
  new City("San Francisco", "California", "CA",	"Jesse", "Morris",	"jesse@pieforbreakfast.com", "https://www.eventbrite.com/e/dash-9-san-francisco-tickets-32963312154", "-08:00", "America/Los_Angeles", 0, "18"),
  new City("Seattle", "Washington", "WA",	"Melitta", "Riley",	"melitta.riley@gmail.com", "https://www.eventbrite.com/e/dash-9-seattle-tickets-33139881277", "-08:00", "America/Los_Angeles", 0, "24", -1),
  new City("St. Louis", "Missouri", "MO",	"Julie", "Buchheit",	"escapefromstl@gmail.com", "https://www.eventbrite.com/e/dash-9-st-louis-tickets-32410729364", "-06:00", "America/Chicago", -1),
  new City("Washington", "D.C.", "DC",	"Steve", "Gaddy",	"nittany1995@gmail.com", "https://www.eventbrite.com/e/dash-9-washington-dc-tickets-32131026766", "-05:00", "America/New_York", 0),
  new City("London", "United Kingdom",	"GBR", "Jan", "Schneider",	"schneider.jan@gmail.com", "https://www.eventbrite.co.uk/e/dash-9-london-tickets-32385403614", "-00:00", "Europe/London", 1),
  new City("Enschede", "Netherlands",	"NLD", "Ronald", "Meijer",	"ronald@ronaldm.nl", "https://www.eventbrite.nl/e/dash9-enschede-tickets-32444360957", "+01:00", "Europe/Vienna", -0.5)
].sort( (a, b) => { return a.name.localeCompare(b.name) });

const cityMap = cityList.reduce( (map, city) => {
  map[city.slug] = city;
  return map;
}, {});


function getCityBySlug(citySlug) {
  return cityMap[citySlug];
}

module.exports = {City, cityList, cityMap, getCityBySlug};


// WEBPACK FOOTER //
// ./src/cities/Cities.js